// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Divider,
  Button,
  // TableContainer,
  // Paper,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";
import MDButton from "theme/components/MDButton";

function DataCapturePage() {
  const pageTitle = "Data Capture";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [dataCapture, setDataCapture] = useState(null);
  const [currency, setCurrency] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/data_captures/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            console.log(result.data.data);
            setDataCapture(result.data.data.capture);
            setCurrency(result.data.data.currency);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function getMediaElement(vrf, v) {
    if (v.startsWith("data:image")) {
      return (
        <MDBox
          onClick={async () => {
            const response = await fetch(v);
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, "_blank");
            URL.revokeObjectURL(blobUrl);
          }}
        >
          <img src={v} alt="" width={120} />
        </MDBox>
      );
    }

    if (v.startsWith("data:audio")) {
      return (
        <audio src={v} controls>
          <track default kind="captions" srcLang="en" />
        </audio>
      );
    }

    if (v.startsWith("data:video")) {
      return (
        <video src={v} height={150} controls>
          <track default kind="captions" srcLang="en" />
        </video>
      );
    }

    // Link it externally
    if (v.startsWith("data:")) {
      return (
        <MDBox>
          <a href={`${AppConfig.api_base_url}dff/dl/${vrf}`} target="_blank" rel="noreferrer">
            PREVIEW
          </a>
        </MDBox>
      );
    }

    return (
      <MDBox style={{ wordBreak: "break-word" }}>
        <MDTypography variant="text" fontWeight="light" fontSize={15}>
          {v}
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {dataCapture !== null && (
        <MDBox pt={3} pb={3}>
          <MDBox>
            <Button
              color="dark"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/data-captures/${dataCapture.campaign.reference}`);
              }}
            >
              Back
            </Button>
          </MDBox>
          <MDBox mt={1}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <Card>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Data Collection Information
                        </MDTypography>
                        <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                          <Icon color="success">edit_note</Icon>
                        </MDBox>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDBox>
                          <Table aria-label="campaign information">
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Reference
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {dataCapture.reference}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Campaign
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {dataCapture.campaign.name}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              {dataCapture.campaign_location && (
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Campaign Location
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {dataCapture.campaign_location}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              )}
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Platform Fee
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <small>{currency}</small>
                                    {(dataCapture.platform_fee / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Validation Fee
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <small>{currency}</small>
                                    {(dataCapture.validation_fee / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              {dataCapture.amount > 0 && (
                                <>
                                  <TableRow>
                                    <TableCell>
                                      <MDTypography variant="h6" fontWeight="regular">
                                        Amount
                                      </MDTypography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <MDTypography variant="h6" fontWeight="light">
                                        <small>{currency}</small>
                                        {(dataCapture.amount / 100).toLocaleString("en", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </MDTypography>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <MDTypography variant="h6" fontWeight="regular">
                                        Payment Fee
                                      </MDTypography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <MDTypography variant="h6" fontWeight="light">
                                        <small>{currency}</small>
                                        {(dataCapture.payment_fee / 100).toLocaleString("en", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </MDTypography>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <MDTypography variant="h6" fontWeight="regular">
                                        Amount Settled
                                      </MDTypography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <MDTypography variant="h6" fontWeight="light">
                                        <small>{currency}</small>
                                        {(dataCapture.settle_amount / 100).toLocaleString("en", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </MDTypography>
                                    </TableCell>
                                  </TableRow>
                                </>
                              )}
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Location
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    <a
                                      rel="noreferrer"
                                      target="_blank"
                                      href={`https://maps.google.com?q=${dataCapture.latitude},${dataCapture.longitude}`}
                                    >
                                      <Icon>location_on</Icon>
                                    </a>
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="regular">
                                    Date
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {dataCapture.date}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card>
                    <MDBox mb={3}>
                      <MDBox p={2}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            Agent Details
                          </MDTypography>
                          <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                            <Icon color="warning">support_agent</Icon>
                          </MDBox>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDBox>
                            <Table>
                              <TableBody>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Name
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {dataCapture.agent.name}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Staff ID
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {dataCapture.agent.staff_number != null
                                        ? dataCapture.agent.staff_number
                                        : "N/A"}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Email Address
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {dataCapture.agent.email_address
                                        ? dataCapture.agent.email_address
                                        : "N/A"}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Phone Number
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {dataCapture.agent.phone_number
                                        ? dataCapture.agent.phone_number
                                        : "N/A"}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="regular">
                                      Agent Group
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {dataCapture.agent.group}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={5}>
            <Card>
              <MDBox>
                <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    Captured Information
                  </MDTypography>
                  <MDButton
                    variant="outlined"
                    color="dark"
                    iconOnly
                    // onClick={() => {
                    //   const downloadUrl = `${AppConfig.api_base_url}campaigns/reports/${campaign.reference}/${accountInfo.user.reference}`;
                    //   window.open(downloadUrl, "_blank");
                    // }}
                  >
                    <Icon>dynamic_form</Icon>
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
            <MDBox mt={3}>
              {Object.entries(dataCapture.data).map(([i, section]) => (
                <MDBox mb={3}>
                  <Card>
                    <MDBox id={`ref_${i}`} mb={2}>
                      <MDBox ml={2} mt={2}>
                        <MDTypography variant="h6" fontWeight="bold" textTransform="capitalize">
                          {section.name}
                        </MDTypography>
                        <Divider />
                      </MDBox>
                      <Table>
                        <TableBody>
                          {section.items.map((item) => (
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="regular">
                                  {item.name}
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDBox>
                                  {typeof item.value === "object" ? (
                                    <MDBox>
                                      {Array.isArray(item.value) ? (
                                        <MDBox>
                                          {item.value.map((objRow) =>
                                            Object.entries(objRow).map(([x, y]) => (
                                              <>
                                                <MDTypography
                                                  variant="text"
                                                  fontWeight="regular"
                                                  fontSize={15}
                                                >
                                                  {x}
                                                </MDTypography>
                                                <MDTypography
                                                  fontSize={15}
                                                  variant="text"
                                                  fontWeight="light"
                                                >
                                                  {y}
                                                </MDTypography>
                                              </>
                                            ))
                                          )}
                                        </MDBox>
                                      ) : (
                                        <div>
                                          {Object.entries(item.value).map(([x, y]) => (
                                            <div>
                                              <MDTypography
                                                variant="text"
                                                fontWeight="regular"
                                                fontSize={15}
                                              >
                                                {x}
                                              </MDTypography>
                                              <MDTypography
                                                fontSize={15}
                                                variant="text"
                                                fontWeight="light"
                                              >
                                                {y}
                                              </MDTypography>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </MDBox>
                                  ) : (
                                    <div>
                                      {typeof item.value === "string" ? (
                                        getMediaElement(item.reference, item.value)
                                      ) : (
                                        <MDTypography
                                          variant="text"
                                          fontWeight="light"
                                          fontSize={15}
                                          style={{ wordWrap: "break-word" }}
                                        >
                                          {item.value}
                                        </MDTypography>
                                      )}
                                    </div>
                                  )}
                                </MDBox>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </MDBox>
                  </Card>
                </MDBox>
              ))}
            </MDBox>
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default DataCapturePage;
